<template>
  <div id="container" class="cs_st grid-container">
    <!-- Location START -->
    <!-- TODO: Should use Subbar component -->
    <Sidebar />
    <BaseLocation current-group-name="onlyTeacher" />
    <!--QNA-->
    <div class="section fill">
      <div class="inner">
        <h2>증정 요청</h2>
        <p class="sub">
          캠퍼스북에 가입된 출판사들의 정보를 확인하신 후 증정본 요청을 하실 수
          있습니다.
        </p>
        <!-- Tab START -->

        <!-- Tab END -->

        <template>
          <ul class="publish_list">
            <li>
              <div class="comp_name">출판사명</div>
              <div class="comp_number">전화번호</div>
              <div class="comp_address">위치</div>
              <div class="comp_email">이메일</div>
              <div class="comp_link">홈페이지</div>
            </li>
            <li
              v-for="(pub, i) in getPublishListForPages"
              :key="i"
              class="publish_list_item"
            >
              <div class="comp_name" style="text-align: left;">
                {{ pub.publisherNm }}
              </div>
              <a
                :href="`tel:${pub.telNo}`"
                class="comp_number"
                style="text-align: left;"
                >{{ pub.telNo }}</a
              >

              <div class="comp_address" style="text-align: left;">
                {{ pub.address }}
              </div>
              <div class="comp_email" style="text-align: left;">
                {{ pub.chargerEmail }}
              </div>
              <div class="comp_link">
                <a :href="pub.url" target="_blank" class="box_btn line">
                  <!-- <span class="link_ico"></span> -->
                  <span>바로가기</span></a
                >
              </div>
            </li>
          </ul>
          <Pagination
            :current-page="currentPage"
            :total-count="getPublishInfo.totalCount || 0"
            :item-per-page="publishPerPage"
            @paginate="paginate"
          />
        </template>
      </div>
      <transition name="modal-fade">
        <Modal v-if="showErrorModal">
          <div v-on-clickaway="returnRoute" class="ly_pop_wrap">
            <div class="ly_pop_content ly_pop_msg ly_txt ly_alert">
              <div class="ly_inner">
                <p>
                  {{ modalTitleTxt }}
                </p>
                <div class="btnWrap">
                  <button class="box_btn" @click="returnRoute">
                    <span class="an_t">확인</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseLocation from '../../components/base/BaseLocation.vue'
import Sidebar from '../../components/library/Sidebar.vue'

export default {
  name: 'Present',
  components: { BaseLocation, Sidebar },

  data() {
    return {
      currentPage: 1,
      publishPerPage: 10,
      showErrorModal: false
    }
  },
  computed: {
    ...mapGetters([
      'getEvents',
      'getEventTotalCount',
      'isSidebarOpen',
      'getPublishListForPages',
      'getPublishInfo'
    ])
  },
  async mounted() {
    if (this.$store.getters.getCurrentUser?.memberTp !== '2000') {
      // this.isErrors = false
      this.toggleErrorModal(`교강사 전용 페이지입니다.`, false)
    }

    this.loadPublishList()
  },
  methods: {
    toggleErrorModal() {
      this.modalTitleTxt = '교강사 전용 페이지입니다.'
      this.showErrorModal = !this.showErrorModal
    },
    closeModal() {
      this.showErrorModal = false
    },
    returnRoute() {
      this.closeModal()
      this.$router.push({
        name: 'store'
      })
    },
    async loadPublishList() {
      //   const { search, currentPage, publishPerPage } = this
      try {
        await this.$store.dispatch('fetchPublishList', {
          pageRow: this.publishPerPage,
          pageNo: this.currentPage
        })
      } catch (err) {
        console.log(err)
      }
    },
    openPublishSite(url) {
      window.open(
        url,
        'publish-site',
        'height=' + screen.height + ',width=' + screen.width + 'fullscreen=yes'
      )
    },
    paginate(page) {
      this.currentPage = page
      this.loadPublishList()
    }
  }
}
</script>
<style src="@/assets/css/page_customer.css" scoped></style>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
.cs_st .section .inner li > a {
  width: auto;
  height: auto;
  display: inline;
}
.publish_list {
  width: 100%;
  margin-top: 48px;
  li {
    min-height: 48px;
    display: grid;
    align-items: center;
    grid-template-columns: 180px minmax(40px, 140px) minmax(40px, 320px) 214px 122px;
    border-bottom: 1px solid black;
    * {
      text-align: center;
    }

    .comp_link,
    .comp_address {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .publish_list_item {
    min-height: 60px;
    gap: 12px 0px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  }
}
@media (max-width: 768px) {
  .publish_list {
    width: 100%;
    li {
      display: none;
    }
    .publish_list_item {
      margin-top: 24px;
      padding: 8px 0px;
      display: grid;
      border-radius: 4px;
      overflow: hidden;
      box-shadow: 0px 4px 12px rgba(34, 34, 34, 0.05);
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      margin-bottom: 12px;
      grid-template-columns: 1fr minmax(60px, 12%);
      grid-template-rows: 32px 24px 24px 24px;
      grid-template-areas:
        'comp_name comp_link'
        'comp_address comp_link'
        'comp_number comp_link'
        'comp_email comp_link';
      gap: 0px;
      > * {
        text-align: left;
        padding-left: 1rem;
        font-size: 0.9rem;
      }
      .comp_name {
        grid-area: comp_name;
        font-size: 1.5rem;
      }
      .comp_link {
        align-self: stretch;
        grid-area: comp_link;

        padding: 0;
        > a {
          display: flex;
          padding: 0;
          align-items: center;
          justify-content: center;
          border-radius: 6px;
          width: 100%;
          height: 100%;
          flex-direction: column;
          .link_ico {
            display: block;
            width: 16px;
            height: 16px;
            // background-image: url('../../assets/images/table_link_ico.svg');
            background-repeat: no-repeat;
            background-position: center;
            background-size: 16px;
            color: transparent;
          }
        }
      }
      .comp_number {
        grid-area: comp_number;
      }
      .comp_address {
        grid-area: comp_address;
      }
      .comp_charger {
        display: none;
      }
      .comp_email {
        grid-area: comp_email;
      }
      .comp_address,
      .comp_email,
      .comp_number {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
.ly_inner {
  p {
    text-align: center;
    padding-bottom: 24px;
  }
  .btnWrap {
    text-align: center;
  }
}
.box_btn.line {
  height: auto;
  padding: 8px 16px;
  color: $h_BLUE_01;

  font-family: Noto Sans KR;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;

  letter-spacing: -0.03em;
}
</style>
